import React from "react";
import {graphql, useStaticQuery} from "gatsby";

const OnlineStore = () => {

    const { acfTheme, firstProduct } = useStaticQuery(graphql`
        query QueryAcfThemeOnlineStore {
          acfTheme: wp {
            acfThemeGeneralSettings {
              aCFoptionTemplate {
                micromarkup {
                  addresslocality
                  alternatename
                  description
                  email
                  name
                  streetaddress
                  telephone 
                  logo {
                    node {
                      localFile {
                        publicURL
                      }
                    }
                  }
                }  
              }
            }
          } 
           
          firstProduct: allWpProduct(limit: 1, sort: {date: DESC}) {
            nodes {
              featuredImage {
                node {
                  localFile {
                    publicURL
                  }
                }
              }
            } 
          }

        }  
    `);

    const { micromarkup } = acfTheme.acfThemeGeneralSettings.aCFoptionTemplate;
    const productImage = firstProduct?.nodes?.[0]?.featuredImage?.node?.localFile?.publicURL;

    const imageUrl = "https://molfarpublishing.ua" + productImage;


    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "OnlineStore",
        "name": micromarkup.alternatename, //"Видавництво Molfar",
        "description": micromarkup.description , // "Видавництво Molfar ᐉ Книги, манґа, артбуки ᐉ Вигідні ціни ✓ Акції та знижки ✓ Доставка по всій Україні",
        "url": "https://molfarpublishing.ua/",
        "image": imageUrl,
        "logo": micromarkup.logo?.node?.localFile?.publicURL ? "https://molfarpublishing.ua" + micromarkup.logo.node.localFile.publicURL : undefined,
        "address": {
            "@type": "PostalAddress",
            "addressCountry": "Україна",
            "addressLocality": micromarkup.addresslocality
        }
    };

    return (
        <script
            className='OnlineStore'
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
    );
};

export default OnlineStore;
